import React from 'react';
import { Receipt, Building2, FileSpreadsheet, Landmark, HelpCircle } from 'lucide-react';

export interface DocumentTypeBadgeProps {
  type: string | null;
  confidence: number | null;
}

export const DocumentTypeIcon: React.FC<{ type: string | null }> = ({ type }) => {
  switch (type) {
    case 'K1':
      return <Receipt className="w-5 h-5 text-blue-500" />;
    case '1065':
      return <Building2 className="w-5 h-5 text-blue-500" />;
    case 'PL':
      return <FileSpreadsheet className="w-5 h-5 text-green-500" />;
    case 'BANK':
      return <Landmark className="w-5 h-5 text-amber-500" />;
    default:
      return <HelpCircle className="w-5 h-5 text-gray-400" />;
  }
};

export const DocumentTypeBadge: React.FC<DocumentTypeBadgeProps> = ({ type, confidence }) => {
  const getTypeInfo = () => {
    switch (type) {
      case 'K1':
        return { label: 'Schedule K-1', color: 'bg-blue-100 text-blue-800 border-blue-200' };
      case '1065':
        return { label: 'Form 1065', color: 'bg-blue-100 text-blue-800 border-blue-200' };
      case 'PL':
        return { label: 'P&L Statement', color: 'bg-green-100 text-green-800 border-green-200' };
      case 'BANK':
        return { label: 'Bank Statement', color: 'bg-amber-100 text-amber-800 border-amber-200' };
      default:
        return { label: 'Unknown', color: 'bg-gray-100 text-gray-800 border-gray-200' };
    }
  };

  const { label, color } = getTypeInfo();

  return (
    <div className="flex items-center gap-2">
      <span className={`px-2 py-1 text-xs font-medium rounded-full border ${color}`}>
        {label}
      </span>
      {confidence && (
        <span className={`text-xs ${confidence >= 0.8 ? 'text-green-600' : confidence >= 0.6 ? 'text-amber-600' : 'text-red-600'}`}>
          {(confidence * 100).toFixed(0)}% confident
        </span>
      )}
    </div>
  );
};

export default DocumentTypeBadge;
